import { Component, OnInit } from '@angular/core';
import { Message } from '../../classes/Message';
import { IIncidentClosureReasonDTO } from '../../interfaces/incident';
import { MessageService } from 'primeng';
import { JobRejectionReasonDTO } from '../../interfaces/job-rejection/job-rejection-reason.dto.interface';
import { SupplierInboxJobsService } from '../../services';
import { JobRejectionReasonService } from '../../services/job-rejection/job-rejection-reasons.service';

@Component({
  templateUrl: 'manage-job-rejection.component.html',
  styleUrls: ['manage-job-rejection.component.scss'],
})
export class ManageJobRejectionComponent implements OnInit {
  constructor(
    private jobRejectionReasonService: JobRejectionReasonService,
    private messageService: MessageService,
  ) {}

  rejectionReasons: JobRejectionReasonDTO[] = [];
  reasonText: string = '';
  requireText: boolean = false;

  ngOnInit() {
    // load rejection reasons
    this.loadReasons();
  }

  loadReasons() {
    this.jobRejectionReasonService.getJobRejectionReasons(true).then((res) => {
      this.rejectionReasons = res;
    });
  }

  addRejectionReason() {
    var text = this.reasonText.trim();

    if (text == '') {
      this.messageService.add(Message.Error('Reason cannot be blank.', 'Error'));
      return;
    }

    if (
      this.rejectionReasons.findIndex((x) => x.reason.toLowerCase().trim() == text.toLowerCase()) >=
      0
    ) {
      this.messageService.add(Message.Error('The rejection reason already exists.', 'Error'));
    } else {
      let data = <JobRejectionReasonDTO>{
        reason: text,
        requireText: this.requireText,
      };

      this.jobRejectionReasonService.addRejectionReason(data).then(() => {
        this.loadReasons();
        this.reasonText = '';
      });
    }
  }

  reactivateRejectionReason(item: JobRejectionReasonDTO) {
    this.jobRejectionReasonService.activateRejectionReason(item.id).then(() => this.loadReasons());
  }

  deactivateRejectionReason(item: JobRejectionReasonDTO) {
    this.jobRejectionReasonService
      .deactivateRejectionReason(item.id)
      .then(() => this.loadReasons());
  }
}
